import { ResponsiveUiHelper, 
         ConfigService }                  from '..';

/**
 * The service that provide easy access to theme configuration parameters encapsulating the origin, default 
 * values or the business logic related to the override hierarchy.
 */
export class ConfigChatroomThemeService {

   public static getChatroomContainerStyles(vuetifyRef: any): any {
      const defaultStyles: any = {};
      let configStyles: any = null;
      try {
         if (window.botSettings && window.botSettings.customChatroomTheme 
                                && window.botSettings.customChatroomTheme.styles 
                                && window.botSettings.customChatroomTheme.styles.chatroomRootContainer) {

            configStyles =  window.botSettings.customChatroomTheme.styles.chatroomRootContainer;
         }

         if (!configStyles && ConfigService.widgetConfig 
                           && ConfigService.widgetConfig.params 
                           && ConfigService.widgetConfig.params.get('customChatroomTheme')) {

            const paramConfigStyles = JSON.parse(ConfigService.widgetConfig.params.get('customChatroomTheme'));
            if (paramConfigStyles && paramConfigStyles.styles && paramConfigStyles.styles.chatroomRootContainer) {
               configStyles = paramConfigStyles.styles.chatroomRootContainer;
            }
         }

      } finally {
         if (!configStyles) {
            configStyles = defaultStyles;
         }
      }
      return ResponsiveUiHelper.setExplicitConfiguredThemeColors(vuetifyRef, 'light', configStyles);
   }
   
   public static getLoadingAnimationColor(vuetifyRef: any): any {
      let configColor: any = '#333';
      if (window.botSettings   && window.botSettings.customChatroomTheme 
                                          && window.botSettings.customChatroomTheme.colors 
                                          && window.botSettings.customChatroomTheme.colors.loadingAnimation) {
         configColor = window.botSettings.customChatroomTheme.colors.loadingAnimation;                                   
      }
      return ResponsiveUiHelper.replaceByExplicitColor(vuetifyRef, 'light', configColor);
   }

   public static getChatroomPresentationPanelStyles(vuetifyRef: any): any {
      const defaultStyles: any = {};
      let configStyles: any = null;
      try {
         if (window.botSettings && window.botSettings.customChatroomTheme 
                                && window.botSettings.customChatroomTheme.styles 
                                && window.botSettings.customChatroomTheme.styles.chatroomPresentationPanel) {
            configStyles =  window.botSettings.customChatroomTheme.styles.chatroomPresentationPanel;
         }
         if (!configStyles && ConfigService.widgetConfig 
                           && ConfigService.widgetConfig.params 
                           && ConfigService.widgetConfig.params.get('customChatroomTheme')) {

            const paramConfigStyles = JSON.parse(ConfigService.widgetConfig.params.get('customChatroomTheme'));
            if (paramConfigStyles && paramConfigStyles.styles && paramConfigStyles.styles.chatroomPresentationPanel) {
               configStyles = paramConfigStyles.styles.chatroomPresentationPanel;
            }
         }
      } finally {
         if (!configStyles) {
            configStyles = defaultStyles;
         }
      }
      return ResponsiveUiHelper.setExplicitConfiguredThemeColors(vuetifyRef, 'light', configStyles);
   }
   
   public static getChatroomDisclaimerPanelStyles(vuetifyRef: any): any {
      const defaultStyles: any = {};
      let configStyles: any = null;
      try {
         if (window.botSettings && window.botSettings.customChatroomTheme 
                                && window.botSettings.customChatroomTheme.styles 
                                && window.botSettings.customChatroomTheme.styles.chatroomDisclaimerPanel) {
            configStyles =  window.botSettings.customChatroomTheme.styles.chatroomDisclaimerPanel;
         }
         if (!configStyles && ConfigService.widgetConfig 
                           && ConfigService.widgetConfig.params 
                           && ConfigService.widgetConfig.params.get('customChatroomTheme')) {

            const paramConfigStyles = JSON.parse(ConfigService.widgetConfig.params.get('customChatroomTheme'));
            if (paramConfigStyles && paramConfigStyles.styles && paramConfigStyles.styles.chatroomDisclaimerPanel) {
               configStyles = paramConfigStyles.styles.chatroomDisclaimerPanel;
            }
         }
      } finally {
         if (!configStyles) {
            configStyles = defaultStyles;
         }
      }
      return ResponsiveUiHelper.setExplicitConfiguredThemeColors(vuetifyRef, 'light', configStyles);
   }
}
